// src/components/Services.jsx

import React from 'react';

const MarketOpportunity = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
      Market<span className="text-[#680099] ml-2 font-bold">Opportunity</span>
</h2>

      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Category</div>
          <p style={boxContentStyle}> Global Travel Market</p>
          <p style={boxContentStyle}> B2B Travel Travel Market</p>
          <p style={boxContentStyle}> Geographical Focus</p>
        </div>

        {/* Right box */}
        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Statistics and Trends</div>
          <p style={boxContentStyle}> Approx. $9 Trillion; Rapid Growth in Tech-Enabled Travel Solutions.</p>
          <p style={boxContentStyle}> CAGR Of 8-10%; Rising Demand For Customizable, Scalable Travel Tech Solutions</p>
          <p style={boxContentStyle}> India And UAE Are Key Emerging Markets With Demands For Seamless, Technology-Driven Travel Solutions</p>
        </div>
      </div>

      <h5 className="text-xl font-bold text-black mb-3 mt-7"> Identified Market gaps</h5>
      {/* Bullet points list for Identified Market Gaps */}
      <ul style={bulletPointsStyle}>
        <li style={bulletPointItemStyle}> <strong>Customization Needs: </strong>Customization Needs: Limited platforms provide real-time, fully customizable travel options with live pricing.</li>
        <li style={bulletPointItemStyle}> <strong>Integrated Forex Solution: </strong>Few platforms combine travel and forex services, addressing teh dual needs of B2B agents and B2C consumers.</li>
      </ul>
    </div>
  );
};

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px'
};

const bulletPointsStyle = {
  listStyleType: 'disc',  // Bullet points (disc)
  paddingLeft: '20px',    // Indentation for the list
  marginTop: '20px',      // Space above the list
};

const bulletPointItemStyle = {
  fontSize: '18px',       // Font size for the bullet point text
  marginBottom: '10px',   // Space between each bullet point
  lineHeight: '1.6',      // Line height for readability
};

export default MarketOpportunity;
